/**
 * TripList component - Renders a list of trip cards
 */

import { useNavigate } from 'react-router-dom';
import type { Trip } from '../../types/trip';
import TripCard from './TripCard';

interface TripListProps {
  trips: Trip[];
  onEditTrip: (trip: Trip) => void;
  onDeleteTrip: (trip: Trip) => void;
}

export default function TripList({ trips, onEditTrip, onDeleteTrip }: TripListProps) {
  const navigate = useNavigate();

  const handleTripClick = (tripId: string) => {
    navigate(`/trips/${tripId}`);
  };

  if (trips.length === 0) {
    return (
      <div className="mt-4 flex flex-col items-center justify-center p-8 text-center rounded-xl border-2 border-dashed border-gray-200">
        <div className="bg-[#0dccf2]/10 p-4 rounded-full mb-3">
          <svg className="w-8 h-8 text-[#0dccf2]" fill="currentColor" viewBox="0 0 24 24">
            <path d="M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"/>
          </svg>
        </div>
        <p className="text-[#111718] font-bold text-base mb-1">規劃新的旅程？</p>
        <p className="text-gray-500 text-sm mb-4">立即開始組織您的下一次冒險</p>
        <button className="text-[#0dccf2] font-bold text-sm hover:underline">瀏覽目的地</button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 md:grid md:grid-cols-3 md:gap-6">
      {trips.map((trip) => (
        <TripCard
          key={trip.id}
          trip={trip}
          onClick={() => handleTripClick(trip.id)}
          onEdit={() => onEditTrip(trip)}
          onDelete={() => onDeleteTrip(trip)}
        />
      ))}
    </div>
  );
}
